module.exports = __webpack_public_path__ + "img/diario-financiero.14fe35ec.png";